import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PressReleaseCreateContextType {
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

const PressReleaseCreateContext = createContext<PressReleaseCreateContextType | undefined>(undefined);

export const usePressReleaseCreate = () => {
  const context = useContext(PressReleaseCreateContext);
  if (!context) {
    throw new Error('usePressReleaseCreate must be used within a PressReleaseCreateProvider');
  }
  return context;
};

interface PressReleaseCreateProviderProps {
  children: ReactNode;
}

export const PressReleaseCreateProvider: React.FC<PressReleaseCreateProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);

  return (
    <PressReleaseCreateContext.Provider value={{ isOpen, openDialog, closeDialog }}>
      {children}
    </PressReleaseCreateContext.Provider>
  );
};
